import styled from 'styled-components'

export interface LocationFlagIconAttributes {
  isBlur: boolean
}

export const CtaLink = styled.a``

export const LocationFlagIcon = styled.img<LocationFlagIconAttributes>`
  filter: ${(props) => (props.isBlur ? 'grayscale(100%)' : '')};
  height: 30px;
  cursor: pointer;
  margin-left: 10px;
`

export const LocationFlagContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  height: 100%;
`
